export type PendingRequest = { endpoint: string; body: any };
const active = new Set<string>();
const key = (companyId: string) => `ft_pending_request_v1:${companyId}`;
export const pendingEvent = 'ft-pending-request';
export function getPendingRequest(companyId: string): PendingRequest | null {
  const stored = localStorage.getItem(key(companyId));
  return stored ? JSON.parse(stored) : null;
}
export async function submitConfirmed(packet: PendingRequest, send: (packet: PendingRequest) => Promise<any>, retry = false) {
  const companyId = packet.body.companyId;
  if (active.has(companyId)) throw new Error('Envio em andamento. Aguarde.');
  const pending = getPendingRequest(companyId);
  if (pending && !retry) throw new Error('Use Recuperar envio antes de lançar novamente.');
  const original = pending || packet;
  if (!companyId || original.body.companyId !== companyId) throw new Error('Empresa inválida.');
  localStorage.setItem(key(companyId), JSON.stringify(original));
  active.add(companyId);
  window.dispatchEvent(new Event(pendingEvent));
  try {
    const result = await send(original);
    if (!result || result.requestError) {
      if (result?.status >= 400 && result.status < 500 && ![408, 429].includes(result.status)) localStorage.removeItem(key(companyId));
      throw new Error(result?.requestError || 'Sem confirmação. Envio guardado neste navegador; use Recuperar envio.');
    }
    localStorage.removeItem(key(companyId));
    window.dispatchEvent(new CustomEvent('ft-request-confirmed', { detail: { packet: original, result, recovered: retry } }));
    return result;
  } finally {
    active.delete(companyId);
    window.dispatchEvent(new Event(pendingEvent));
  }
}
